var mapLarge;
var mapCoordinate;
var mapTitle = 'The White Room - By Jacob Jan Boerma';
var mapLatitude = 52.372590;
var mapLongitude = 4.894760;
var mapUrl = 'https://www.google.nl/maps/place/Restaurant+The+White+Room/@52.3725878,4.8947802,15z/data=!4m5!3m4!1s0x0:0xaa081b1677b71871!8m2!3d52.3725878!4d4.8947802';

function getMapOptions() {
    return {
        zoom: 15,
        center: new google.maps.LatLng(mapLatitude, mapLongitude, 4),
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        scrollwheel: false,
        draggable: false,
        styles: [{
            "featureType": "water",
            "stylers": [{"visibility": "on"}, {"color": "#b5cbe4"}]
        }, {"featureType": "landscape", "stylers": [{"color": "#efefef"}]}, {
            "featureType": "road.highway",
            "elementType": "geometry",
            "stylers": [{"color": "#83a5b0"}]
        }, {
            "featureType": "road.arterial",
            "elementType": "geometry",
            "stylers": [{"color": "#bdcdd3"}]
        }, {
            "featureType": "road.local",
            "elementType": "geometry",
            "stylers": [{"color": "#ffffff"}]
        }, {
            "featureType": "poi.park",
            "elementType": "geometry",
            "stylers": [{"color": "#e3eed3"}]
        }, {
            "featureType": "administrative",
            "stylers": [{"visibility": "on"}, {"lightness": 33}]
        }, {"featureType": "road"}, {
            "featureType": "poi.park",
            "elementType": "labels",
            "stylers": [{"visibility": "on"}, {"lightness": 20}]
        }, {}, {"featureType": "road", "stylers": [{"lightness": 20}]}]
    }
}

function handleClickMarker() {
    window.open(this.url, '_blank');
}

function initSmallFooterMap() {
    if (document.getElementById('map') != null) {
        var map = new google.maps.Map(document.getElementById('map'), getMapOptions());
        var marker = new google.maps.Marker({
            position: mapCoordinate,
            map: map,
            icon: {
                url: '/assets/dist/img/maps-marker.png',
                anchor: new google.maps.Point(22, 62)
            },
            title: mapTitle,
            url: mapUrl
        });
        google.maps.event.addListener(marker, 'click', handleClickMarker);
    }
}

function initLargeFooterMap() {
    if (document.getElementById('map-large') != null) {
        mapLarge = new google.maps.Map(document.getElementById('map-large'), $.extend(getMapOptions(), {scrollwheel: true, draggable: true}));
        var markerLarge = new google.maps.Marker({
            position: mapCoordinate,
            map: mapLarge,
            icon: {
                url: '/assets/dist/img/maps-marker.png',
                anchor: new google.maps.Point(22, 62)
            },
            title: mapTitle,
            url: mapUrl
        });
        google.maps.event.addListener(markerLarge, 'click', handleClickMarker);
    }
}

function initContactMap() {
    if (document.getElementById('contact-map') != null) {
        var mapContact = new google.maps.Map(document.getElementById('contact-map'), getMapOptions());
        var markerContactPage = new google.maps.Marker({
            position: mapCoordinate,
            map: mapContact,
            icon: {
                url: '/assets/dist/img/maps-marker.png',
                anchor: new google.maps.Point(22, 62)
            },
            title: mapTitle,
            url: mapUrl
        });
        google.maps.event.addListener(markerContactPage, 'click', handleClickMarker);
    }
}

function initFestivalMap() {
    if (document.getElementById('michelin-festival-map') != null) {
        var mapContact = new google.maps.Map(document.getElementById('michelin-festival-map'), getMapOptions());
        var markerContactPage = new google.maps.Marker({
            position: mapCoordinate,
            map: mapContact,
            icon: {
                url: '/assets/dist/img/maps-marker.png',
                anchor: new google.maps.Point(22, 62)
            },
            title: 'Anantara Grand Hotel Krasnapolsky Amsterdam',
            url: 'https://www.google.nl/maps/place/Grand+Caf%C3%A9+Krasnapolsky/@52.3727365,4.8918676,17z/data=!3m1!4b1!4m6!3m5!1s0x47c609c75023fcb1:0x25f297dfd6a6336a!8m2!3d52.3727333!4d4.8944479!16s%2Fg%2F11cmhc4q68?hl=nl&entry=ttu&g_ep=EgoyMDI1MDIyMy4xIKXMDSoASAFQAw%3D%3D'
        });
        google.maps.event.addListener(markerContactPage, 'click', handleClickMarker);
    }
}

function refocusMap() {
    if (document.getElementById('map-large') != null) {
        var fullMap = $('footer .map-opened');
        var isFullMapOpen = fullMap.hasClass('opened');

        mapLarge.panTo(mapCoordinate);
        if (!isFullMapOpen) {
            mapLarge.panBy(-300, null);
        }
    }
}

function initMap() {
    mapCoordinate = new google.maps.LatLng(mapLatitude, mapLongitude, 4);
    initSmallFooterMap();
    initLargeFooterMap();
    initContactMap();
    initFestivalMap();
    refocusMap();
}

$(function () {
    $('footer .toggle-map').on('click', function (e) {
        $('footer .map-opened').toggleClass('opened');
        refocusMap();
    });
});
